export const TELESRV_NAME = 'ShumbulGram';
export const TELESRV_WEB_K_NAME = 'ShumbulGram Web';
export const TELESRV_SCHEME = 'telesrv';
export const TELESRV_PUBLIC_HOST = 'sg.hexaops.ir';
export const TELESRV_PUBLIC_URL = `https://${TELESRV_PUBLIC_HOST}`;
export const TELESRV_WEB_A_URL = 'https://sg.hexaops.ir/';
export const TELESRV_WEB_K_URL = 'https://sg.hexaops.ir/';
export const TELESRV_WEB_DOMAINS = ['sg.hexaops.ir'];
